import React from 'react';
import { KPICard } from '../../ui';
import { useHRTotalStaff } from '../../../hooks/useHRKPIs';
import LoadingSpinner from '../../ui/LoadingSpinner';

import { KPIProps } from '../../../types/kpi';
const TotalStaffKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useHRTotalStaff(branchId, timeRange);

  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری تعداد پرسنل</p>
        {showLoading && (
          <button
            onClick={() => refetch()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <KPICard
        title="کل پرسنل فعال"
        value={data.totalStaff}
        variant="primary"
        accentStyle="corner"
        aria-label={`کل پرسنل فعال: ${data.totalStaff}`}
      />
    </div>
  );
};

export default TotalStaffKPI;